export default "__VITE_ASSET__mqM1dISg__"